// Math Rods strings assigned by FLC. Always ask FLC's translate function;
// do not change the saved activity text or the platform's translation service.
export const MATH_RODS_STRING_IDS = Object.freeze({
  name: 3935,
  description: 3936,
  learnerHelp: 3938,
  authorHelp: 3940,
  optionsHelp: 3941,
  setup: 4069,
  demo: 4070,
  explanation: 4071,
  questions: 213,
  multipleChoice: 4072,
  coaching: 4073,
  correctAnswer: 518,
  incorrectAnswer: 4074,
  addIncorrectAnswer: 4075,
  removeIncorrectAnswer: 4076,
  size: 4077,
  specificFeedback: 949,
  noScreenFigure: 4078,
  twoColumnChart: 4079,
  preserveLearnerWork: 4080,
  copyPreviousSegment: 4081,
  copyPreviousDemo: 4082,
  none: 3815,
  remainder: 4083,
  tens: 4084,
  ones: 4085,
  chartInstructions: 4086,
});

// These are complete help blocks, NOT button labels. Keep line breaks and
// resolve the whole block through one string ID, rather than concatenating
// hardcoded English sentences with localized captions.
export const MATH_RODS_DESCRIPTION = 'Math Rods is a manipulatives template for exploring basic math topics of whole numbers, fractions, measurement, ratio, area, perimeter, symmetry, congruence, patterns, and functions. The objects are rods of different lengths. Each segment includes an explanation or a question, and can include a setup and/or a demo.';

export const MATH_RODS_HELP_TEXT = 'Math Rods activities help you understand math concepts using rods of different length to show the math concepts at work.\nUse the segment boxes to know which segment you are on and move to other segments.\nDrag the rods from the dispenser to the work area.\nUse the operations symbols to display the values of the rods with numbers.';

export const MATH_RODS_MAKE_HELP = 'STEP #1\nClick Add (+) to add a new segment.\nSTEP #2\nEach segment must have an explanation or a question. You can add an audio file to an explanation, and select its text size.\nSTEP #3\nThere are multiple choice and coaching questions. For coaching questions, learners use objects to display the correct answer.\nSPECIFIC FEEDBACK\nMultiple Choice questions can have specific feedback for answers.\nINCORRECT ANSWERS\nCoaching questions can have specific incorrect answers with specific feedback.\nOBJECTS\nDrag objects to the grid. Objects snap to grid squares. Double-click an object to change from horizontal to vertical.\nSAVE CHANGES\nChanges are saved automatically when you add a new segment or click another tab.';

export const MATH_RODS_OPTIONS_HELP = 'WRITING ACTIVITY\nSelect Story Studio (younger children) or Writing Assistant (older children) as the word processor for writing about what they have created with the objects.\nSHOW GRID IN PLAY\nShow the grid or not in the Play App.\nSHOW ANSWER\nYou can decide if learners can be shown the correct answer. If not, select n/a. If you want learners to be shown the correct answer, decide after how many incorrect answers.';

// FLC translate() may return a React span for a localized prettyValue.
// MathRods' canvas/DOM workspace needs plain text, not React nodes.  Never
// use the localized HTML as innerHTML on the workspace.
export function mathRodsString(translate, id, fallback) {
  // Icon-only controls have no visible label. Never ask FLC to translate an
  // empty fallback: translate(0, '') returns 'Translate not found'.
  if (fallback == null || fallback === '') return '';
  if (typeof translate !== 'function') return fallback;
  const value = translate(id, fallback, true);
  if (typeof value === 'string') return value.trim() ? value : fallback;
  const prettyHtml = value && value.props && value.props.dangerouslySetInnerHTML
    && value.props.dangerouslySetInnerHTML.__html;
  if (typeof prettyHtml !== 'string' || !prettyHtml.trim()) return fallback;
  if (typeof document !== 'undefined' && document.createElement) {
    const holder = document.createElement('div');
    holder.innerHTML = prettyHtml;
    return holder.textContent || fallback;
  }
  return prettyHtml.replace(/<[^>]*>/g, '').replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<').replace(/&gt;/g, '>') || fallback;
}

const UI_IDS = Object.freeze({
  'Math Rods': 3935,
  'Setup': 4069,
  'Demo': 4070,
  'Explanation': 4071,
  'Questions': 213,
  'M/C': 4072,
  'Coaching': 4073,
  'Correct Answer': 518,
  'Incorrect Answer': 4074,
  'Add incorrect answer': 4075,
  'Remove incorrect answer': 4076,
  'Specific Feedback': 949,
  'Size': 4077,
  'No Screen Figure': 4078,
  '2-column chart': 4079,
  'Preserve learner work': 4080,
  'Copy previous segment': 4081,
  'Copy final state of last previous demo': 4082,
  'None': 3815,
  'remainder': 4083,
  'Tens': 4084,
  'Ones': 4085,
  'Use 10-rods in Tens and 1-rods in Ones, with at most nine in each column. Leave space between rods.': 4086,
});

export function mathRodsUiLabel(translate, fallback) {
  return mathRodsString(translate, UI_IDS[fallback] || 0, fallback);
}
